// // Get all elements with the class name .hover-column-container
// var hoverColumnContainers = document.querySelectorAll('.hover-column-container');

// // Loop through each .hover-column-container element and add event listeners
// hoverColumnContainers.forEach(function(hoverColumnContainer) {
//     // Get the child elements with the class name .hover-column
//     var hoverColumns = hoverColumnContainer.querySelectorAll('.hover-column');

//     // Loop through each .hover-column element and add event listeners
//     hoverColumns.forEach(function(hoverColumn) {
//         // Add a mouseover event listener to the .hover-column element
//         hoverColumn.addEventListener('mouseover', function() {
//             // Remove 'active' class from all .hover-column elements within the same container
//             hoverColumns.forEach(function(column) {
//                 column.classList.remove('active');
//             });

//             // Add 'active' class to the current .hover-column element
//             hoverColumn.classList.add('active');

//             // Get the .hover-column-content element within the current .hover-column
//             var hoverColumnContent = hoverColumn.querySelector('.hover-column-content');
//             // Get the content height of the p tag within .hover-column-content
//             var contentHeight = hoverColumnContent.querySelector('p').scrollHeight + 'px';

//             // Set the height of .hover-column-content to its content height
//             hoverColumnContent.style.height = contentHeight;
//         });

//         // Add a mouseout event listener to the .hover-column element
//         hoverColumn.addEventListener('mouseout', function() {
//             // Remove 'active' class from the current .hover-column element
//             hoverColumn.classList.remove('active');

//             // Get the .hover-column-content element within the current .hover-column
//             var hoverColumnContent = hoverColumn.querySelector('.hover-column-content');
//             // Set the height of .hover-column-content to 0 on mouseout
//             hoverColumnContent.style.height = '0';
//         });
//     });
// });

// Get all elements with the class name .hover-column-container
// var hoverColumnContainers = document.querySelectorAll('.hover-column-container');

// // Loop through each .hover-column-container element and add event listeners
// hoverColumnContainers.forEach(function(hoverColumnContainer) {
//     // Get the child elements with the class name .hover-column
//     var hoverColumns = hoverColumnContainer.querySelectorAll('.hover-column');

//     // Loop through each .hover-column element and add event listeners
//     hoverColumns.forEach(function(hoverColumn) {
//         // Add a mouseover event listener to the .hover-column element
//         hoverColumn.addEventListener('mouseover', function() {
//             // Remove 'active' class from all .hover-column elements within the same container
//             hoverColumns.forEach(function(column) {
//                 column.classList.remove('active');
//             });

//             // Add 'active' class to the current .hover-column element
//             hoverColumn.classList.add('active');

//             // Get the .hover-column-content element within the current .hover-column
//             var hoverColumnContent = hoverColumn.querySelector('.hover-column-content');
//             // Get the <p> tag within .hover-column-content
//             var paragraph = hoverColumnContent.querySelector('p');
//             // Get the content height of the <p> tag
//             var contentHeight = paragraph.scrollHeight + 'px';

//             // Set the height of the <p> tag to its content height
//             paragraph.style.height = contentHeight;
//         });

//         // Add a mouseout event listener to the .hover-column element
//         hoverColumn.addEventListener('mouseout', function() {
//             // Remove 'active' class from the current .hover-column element
//             hoverColumn.classList.remove('active');

//             // Get the .hover-column-content element within the current .hover-column
//             var hoverColumnContent = hoverColumn.querySelector('.hover-column-content');
//             // Get the <p> tag within .hover-column-content
//             var paragraph = hoverColumnContent.querySelector('p');
//             // Set the height of the <p> tag to 0 on mouseout
//             paragraph.style.height = '0';
//         });
//     });
// });
// Get all elements with the class name .hover-column-container
var hoverColumnContainers = document.querySelectorAll('.hover-column-container');

// Loop through each .hover-column-container element and add event listeners
hoverColumnContainers.forEach(function(hoverColumnContainer) {
    // Get the child elements with the class name .hover-column
    var hoverColumns = hoverColumnContainer.querySelectorAll('.hover-column');

    // Loop through each .hover-column element and add event listeners
    hoverColumns.forEach(function(hoverColumn, index) {
        // Add 'active' class to the first .hover-column by default
        // if (index === 0) {
        //     hoverColumn.classList.add('active');
        // }

        // Add a mouseover event listener to the .hover-column element
        hoverColumn.addEventListener('mouseover', function() {
            // Remove 'active' class from all .hover-column elements within the same container
            hoverColumns.forEach(function(column) {
                column.classList.remove('active');
            });

            // Add 'active' class to the current .hover-column element
            hoverColumn.classList.add('active');

            // Get the .hover-column-content element within the current .hover-column
            var hoverColumnContent = hoverColumn.querySelector('.hover-column-content');
            // Get the <p> tag within .hover-column-content
            var paragraph = hoverColumnContent.querySelector('.paragraph');
            // Get the content height of the <p> tag
            var contentHeight = paragraph.scrollHeight + 'px';

            // Set the height of the <p> tag to its content height
            paragraph.style.height = contentHeight;
        });

        // Add a mouseout event listener to the .hover-column element
        hoverColumn.addEventListener('mouseout', function() {
            // Remove 'active' class from the current .hover-column element
            hoverColumn.classList.remove('active');

            // Get the .hover-column-content element within the current .hover-column
            var hoverColumnContent = hoverColumn.querySelector('.hover-column-content');
            // Get the <p> tag within .hover-column-content
            var paragraph = hoverColumnContent.querySelector('.paragraph');
            // Set the height of the <p> tag to 0 on mouseout
            paragraph.style.height = '0';
        });

        // Set the height of <p> elements to 0 for all but the first .hover-column
        // if (index !== 0) {
        var hoverColumnContent = hoverColumn.querySelector('.hover-column-content');
        var paragraph = hoverColumnContent.querySelector('.paragraph');
        paragraph.style.height = '0';
        // }
    });
});
